import styled from "styled-components";

export const Section = styled.div`
  margin: 0 16px;
`;

export const PersuasionCard = styled.div<{ $hasBg?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 90px;
  border-radius: 16px;
  border: 1px solid #3023ae;
  background: ${({ $hasBg }) =>
    $hasBg
      ? "#f5f3ff"
      : "linear-gradient(-75.6deg, #fff 15.66%, rgba(233, 212, 255, 0.29) 96.1%), linear-gradient(90deg, #fff 0%, #fff 100%)"};
  overflow: hidden;
  min-width: 0;
`;

export const CardBackground = styled.div<{ $src: string }>`
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background-image: url(${({ $src }) => $src});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  z-index: 0;
`;

export const CardForeground = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  gap: 8px;
  flex: 1;
  min-height: 90px;
  padding: 15px;
  box-sizing: border-box;
`;

export const TextCol = styled.div`
  flex: 1;
  min-width: 0;
  align-self: center;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const LineHeading = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  background: linear-gradient(184deg, #3023ae 0%, #c86dd7 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  span {
    color: inherit;
  }
`;

export const LineTitle = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  color: #000;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    color: inherit;
  }
`;

export const LineSubtitle = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  color: #4a4a4a;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    color: inherit;
  }
`;

export const ExtraFooter = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  color: #4a4a4a;
  margin-top: 2px;
`;

export const GraphicCol = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 75px;
  min-height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  align-self: flex-start;
`;
